import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getArticleList,
	addNewArticle,
	updateArticle,
	deleteArticle,
	getArticle,
	getArticleMultiple,
} from './thunk';

export const initialState = {
	itemArticleList: [],
	itemArticleDetail: null,
	isArticleLoading: false,
	isArticleSuccess: false,

	articleList: [],
	articleListSelect: [],
	
    itemArticleCategoryDetail: {},
    itemArticleComplianceStatusDetail: {},
    itemArticleComplianceMatrixDetail: {},


	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,	

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const ArticleSlice = createSlice({
	name: 'Article',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getArticle.fulfilled, (state, action) => {
			state.isArticleLoading = false;
			state.isArticleSuccess = true;
			state.itemArticleDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getArticle.pending, state => {
			state.isArticleLoading = true;
			state.isArticleSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getArticle.rejected, (state, action) => {
			state.isArticleLoading = false;
			state.isArticleSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		

		builder.addCase(getArticleMultiple.pending, state => {
			state.isArticleSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getArticleMultiple.fulfilled, (state, action) => {
			state.itemArticleList = action.payload;
			state.articleList = action.payload;
			state.isLoadingList = false;
			state.isArticleSuccess = true;
			

			let articleListSelect = [];
			action.payload.map(item =>
				articleListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.articleListSelect = articleListSelect;
		});
		builder.addCase(getArticleMultiple.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isArticleSuccess = true;
		});
		

		builder.addCase(getArticleList.pending, state => {
			state.isArticleSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getArticleList.fulfilled, (state, action) => {
			state.itemArticleList = action.payload;
			state.articleList = action.payload;
			state.isLoadingList = false;
			state.isArticleSuccess = true;

			let articleListSelect = [];
			action.payload.map(item =>
				articleListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.articleListSelect = articleListSelect;
		});
		builder.addCase(getArticleList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isArticleSuccess = true;
		});
		builder.addCase(addNewArticle.fulfilled, (state, action) => {
			state.itemArticleList.push(action.payload);
			state.articleList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewArticle.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewArticle.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateArticle.fulfilled, (state, action) => {
			state.itemArticleList = state.itemArticleList.map(article =>
				article.articlename === action.payload.old_article
					? { ...article, ...action.payload.updated_article }
					: article
			);
			state.articleList = state.articleList.map(article =>
				article._id.toString() === action.payload._id.toString()
					? { ...article, ...action.payload }
					: article
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateArticle.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateArticle.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteArticle.fulfilled, (state, action) => {
			state.itemArticleList = current(state.itemArticleList).filter(
				item => item._id !== action.payload._id
			);
			state.articleList = current(state.articleList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteArticle.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteArticle.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		

	},
});

export const { setRequireCloseModal } = ArticleSlice.actions;

export default ArticleSlice.reducer;
